export default "__VITE_ASSET__xpWArLD___"